import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Field } from "formik";
import * as moment from 'moment';
import { useStripe } from '@stripe/react-stripe-js';
import { KEY } from 'web/components/utils/stripeKey';
import { BIDFORMAT } from 'web/components/utils/dateOfBirthValidation';
import Button from 'web/components/Button';
import UploadSpecification from 'web/components/UploadSpecification';
import DebitForm from 'web/pages/private/CommonPages/ManageAccount/AddCardPopup/Credit-Card/debit-form/debitForm';
import RadioButton from "web/components/form-elements/RadioButton";
import DecimalNumberInput from 'web/components/form-elements/DecimalNumberInput';
import DatePicker from 'web/components/form-elements/DatePicker';
import AlertModal from 'web/components/AlertModal';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { fetchLanguageContentNew } from "redux/actions/language";
import { uploadSpecification } from 'redux/actions/postLoad';
import { showAppLoader, hideAppLoader } from 'redux/actions/app';
import Spinner from 'web/components/Spinner';

import { paymentMethodCreate, paymentMethodProfileCreate, profileCreateBuyerSeller } from 'redux/actions/payment';
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './popup.scss';

export default ({ pageData, modalType, isOpen, toggle, callBackModal, onClickHander }) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  let history = useHistory();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const token = localStorage.getItem("token");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [modalAlert, setModalAlert] = useState();
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [taxOrLicenseIsRequired, setTaxOrLicenseIsRequired] = useState(false)
  const [taxLicenseOptions, setTaxLicenseOptions] = useState()
  const [selectTaxId, setSelectTaxId] = useState('0');

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Payment_Page) setPageLanguageContents(languageContentNew.H8_Nav_Payment_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  useEffect(() => {
    // during profile change from buyer to buysell, tax or license is needed, 
    // but there wont be any existing tax or license details, so only two options is shown (tax and license radios)

    // in case of sublocation user adding a seller remittance details, existing tax/license, new tax, new license (3 radios)
    // if seller remittance is already there, these radios not needed
    if (!(pageData?.sellerPaymentDetails?.bankDetails || pageData?.sellerPaymentDetails?.cardDetails)) {
      let taxIdTypes = [{
        value: "1",
        label: "New Tax Id",
      },
      {
        value: "2",
        label: "New License",
      }]
      if (pageData?.userDetails?.license && pageData?.userDetails?.license !== '') {
        taxIdTypes.unshift({
          value: "0",
          label: "Exiting License",
        })
        setTaxOrLicenseIsRequired(true)
      } else if (pageData?.userDetails?.tax && pageData?.userDetails?.tax !== '') {
        taxIdTypes.unshift({
          value: "0",
          label: "Exiting Tax Id",
        })
        setTaxOrLicenseIsRequired(true)
      }
      setTaxLicenseOptions(taxIdTypes)
    }
  }, [])

  const [paymentType, setPaymentType] = useState("bankAccount");

  //set default bank account
  useEffect(() => {
    setPaymentType("bankAccount")
  }, [toggle])

  const radioTypes = [
    {
      value: "bankAccount",
      label: "Bank Account",
    },
    {
      value: "debitCard",
      label: "Debit Card",
    },
  ];

  const getRegisterInitialValues = () => {
    let taxIdTypeValue = '1'
    if (taxOrLicenseIsRequired) taxIdTypeValue = '0'

    return {
      accountHolderName: '',
      bankAccount: '',
      bankRouting: '',
      accountType: 'bankAccount',
      taxId: '',
      taxIdType: taxIdTypeValue,
      firstName: '',
      lastName: '',
      dob: '',
      drivingLicense: '',
      drivingLicenseDoc: '',
      drivingLicenseDocForStripe: '',
    }
  }
  const VALIDATION_SCHEMA = (selectTaxId) => {
    let schemaAttributes
    if (selectTaxId === '1') {
      schemaAttributes = {
        accountHolderName: Yup.string().trim().required('Please enter account holder name.'),
        bankAccount: Yup.string().trim().required('Please enter account number.'),
        bankRouting: Yup.string().trim().required('Please enter routing number.'),
        taxId: Yup.string().trim().min(9, 'Tax ID is minimum 9 digits.').required('Tax ID is required.'),
      };
    } else if (selectTaxId === '2') {
      schemaAttributes = {
        accountHolderName: Yup.string().trim().required('Please enter account holder name.'),
        bankAccount: Yup.string().trim().required('Please enter account number.'),
        bankRouting: Yup.string().trim().required('Please enter routing number.'),
        drivingLicense: Yup.string().trim().min(7, "Driver's License Number should be minimum 7 digits.").required("Driver's License Number is required."),
        dob: Yup.date()
          .required("You are not under 18 years of age.").nullable()
          .transform(v => (v instanceof Date && !isNaN(v) ? v : null))
          .test("dob", "Users must be over 18 years of age.", (value) => {
            return moment().diff(moment(value), 'years') >= 18;
          }),
        firstName: Yup.string().trim().required('First Name is required.'),
        lastName: Yup.string().trim().required('Last Name is required.'),
      };
    } else {
      schemaAttributes = {
        accountHolderName: Yup.string().trim().required('Please enter account holder name.'),
        bankAccount: Yup.string().trim().required('Please enter account number.'),
        bankRouting: Yup.string().trim().required('Please enter routing number.'),
      };
    }
    return Yup.object().shape(schemaAttributes);
  };

  const onChangeTaxHandler = (e, props, setFieldValue) => {
    setFieldValue("taxIdType", e.target.value)
    setSelectTaxId(e.target.value)
    if (e.target.value !== 2) {
      setFieldValue("drivingLicense", '')
      setFieldValue("uploadImage", '')
      setFieldValue("dob", '')
      setFieldValue("taxId", '')
    }
    let date = new Date();
    let plusTwo = date.setFullYear(date.getFullYear() - 18)
    let dateSet = new Date(plusTwo)
    let bidDate = moment(dateSet).format(BIDFORMAT)
    setFieldValue('dob', bidDate)
  };

  const onChangeHandler = (e, props, setFieldValue) => {
    setFieldValue("accountHolderName", '')
    setFieldValue("bankAccount", '')
    setFieldValue("bankRouting", '')

    const { setTouched, validateForm, isValid } = props;
    validateForm();
    setTouched({});
    setPaymentType(e.target.value);
  };

  const callBackFun = () => {
    toggle(!isOpen)
  }

  let fileArr = [];
  const [driverLisenceArr, setDriverLisenceArr] = useState();

  const updateDriversLicenseImage = async (val, props) => {
    const { setFieldValue } = props;
    setFieldValue('drivingLicenseDocForStripe', val)
    setDriverLisenceArr(val)
    let formData = new FormData();
    formData.append('uploadSpecification', val);
    let token = ''
    if (val !== undefined) {
      let response = await dispatch(uploadSpecification(formData, token));
      if (response.status === 'SUCCESS') {
        let value = response.payload
        if (value && value.length > 0) {
          setFieldValue('drivingLicenseDoc', value[0])
        }
      }
    } else {
      setFieldValue('drivingLicenseDoc', '')
    }
  }

  const licenseTypeAttach = (props) => {
    return (
      <div className='licenseFromWrapper'>
        <div className="row mx-0">
          <div className='col-6'>
            <div className="my-2 label-color">
              <p>DriversLicense<span class="star">*</span></p>
            </div>
            <TextInput
              name="drivingLicense"
              maxLength={20}
              inputType="textAndNumber"
              placeholder='DriversLicense'
            />
          </div>
          <div className="col-6">
            <div className="my-2 label-color">
              <p>DOB<span class="star">*</span></p>
            </div>
            <div className="field date-of-birth">
              <DatePicker name="dob" />
            </div>
          </div>
        </div>
        <div className="row mx-0">
          <div className='col-6'>
            <div className='my-2 label-color'>
              <p>First Name<span class="star">*</span></p>
            </div>
            <div>
              <TextInput name='firstName' inputType="text" placeholder="Enter First Name" />
            </div>
          </div>
          <div className='col-6'>
            <div className='my-2 label-color'>
              <p>Last Name<span class="star">*</span></p>
            </div>
            <div>
              <TextInput name='lastName' inputType="text" placeholder="Enter Last Name" />
            </div>
          </div>
        </div>

        <div className="row mx-0">
          <div className="col-12 step3">
            <div className="my-2  label-color ">
              <p>Upload Driver's License<span class="star">*</span></p>
              {/* <span className='star'>*</span> */}
            </div>
            <div className="stepUpload">
              <UploadSpecification
                name="drivingLicenseDoc"
                acceptFiles={"image/png,image/jpeg"}
                props={props}
                ProfileName=""
                CompanyName=""
                pageType=""
                fileArr={fileArr}
                imageLoadCallBack={(imageArr) => { }}
                callBackFun={(imageArr) => {
                  updateDriversLicenseImage(imageArr, props)
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  const submitHandler = async (props) => {
    if (taxLicenseOptions) {
      if (props.values.taxIdType === '1') {
        if (!props.values.taxId) {
          setModalContent('Tax Id is required.')
          setModalLink('');
          toggleModal();
          return
        } else {
          paymentFunctionWithTaxId(props)
        }
      } else if (props.values.taxIdType === '2') {
        if (!props.values.drivingLicense) {
          setModalContent('Driving license is required.')
          setModalLink('');
          toggleModal();
          return
        }
        else if (!props.values.firstName) {
          setModalContent('First name is required.')
          setModalLink('');
          toggleModal();
          return
        }
        else if (!props.values.lastName) {
          setModalContent('Last name is required.')
          setModalLink('');
          toggleModal();
          return
        }
        else if (!driverLisenceArr) {
          setModalContent("Please upload driver's license first.");
          setModalLink('');
          toggleModal();
          return
        } else if (!(moment().diff(moment(props.values.dob), 'years') >= 18)) {
          setModalContent('You are not under 18 years of age.')
          setModalLink('');
          toggleModal();
          return
        } else {
          paymentFunctionWithLicense(props)
        }
      } else {
        if (pageData?.userDetails?.license && pageData?.userDetails?.license !== '') {
          paymentFunctionWithLicense(props)
        } else if (pageData?.userDetails?.tax && pageData?.userDetails?.tax !== '') {
          paymentFunctionWithTaxId(props)
        }
      }
    } else {
      addAccount(props, '')
    }
  };

  const paymentFunctionWithTaxId = async (props) => {
    let businessType = "company"
    const result = await stripe.createToken('account', {
      business_type: businessType,
      company: {
        tax_id: props.values.taxIdType === '1' ? props.values.taxId : pageData?.userDetails?.tax,
        name: pageData?.userDetails?.companyName,
        address: {
          line1: `${pageData?.userDetails?.address?.address1} ${pageData?.userDetails?.address?.address2 ? pageData?.userDetails?.address?.address2 : ''}`,
          city: pageData?.userDetails?.address?.city,
          state: pageData?.userDetails?.address?.state,
          postal_code: pageData?.userDetails?.address?.zipCode,
        },
      },
      tos_shown_and_accepted: true,
    }).then(function (result) {
      if (result.token) {
        addAccount(props, result.token.id)
      }
      if (result.error) {
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    });
  }

  const paymentFunctionWithLicense = async (props) => {
    let businessType = 'individual'

    dispatch(showAppLoader())
    const data = new FormData();
    data.append('file', props.values?.drivingLicenseDocForStripe);
    data.append('purpose', 'identity_document');
    const fileResult = await fetch('https://uploads.stripe.com/v1/files', {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${KEY}` },
      body: data,
    });
    const fileData = await fileResult.json();

    let dayMonthYear = props.values.taxIdType === '0' ? pageData?.userDetails?.dob?.split('-') : props.values.dob.split('-')
    const result = await stripe.createToken('account', {
      business_type: businessType,
      individual: {
        first_name: props.values.taxIdType === '0' ? pageData?.userDetails?.firstName : props.values.firstName,
        last_name: props.values.taxIdType === '0' ? pageData?.userDetails?.lastName : props.values.lastName,
        address: {
          line1: `${pageData?.userDetails?.address?.address1} ${pageData?.userDetails?.address?.address2 ? pageData?.userDetails?.address?.address2 : ''}`,
          city: pageData?.userDetails?.address?.city,
          state: pageData?.userDetails?.address?.state,
          postal_code: pageData?.userDetails?.address?.zipCode,
        },
        email: pageData?.userDetails?.emailId,
        dob: {
          day: dayMonthYear[2],
          month: dayMonthYear[1],
          year: dayMonthYear[0]
        },
        ssn_last_4: '1234',
        verification: {
          document: {
            front: fileData.id
          },
        },
      },
      tos_shown_and_accepted: true,
    }).then(function (result) {
      dispatch(hideAppLoader())
      if (result.token) {
        addAccount(props, result.token.id)
      }
      if (result.error) {
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    });
  }

  const addAccount = async (props, accountToken) => {
    if (props.values.accountHolderName !== '' && props.values.bankRouting !== '' && props.values.bankAccount !== '') {
      let bankAccountParams = {
        country: 'US',
        currency: 'usd',
        account_holder_name: props.values.accountHolderName,
        account_holder_type: 'individual',
        routing_number: props.values.bankRouting,
        account_number: props.values.bankAccount,
      };

      const result = await stripe.createToken('bank_account', bankAccountParams);

      if (result.error) {
        if (result.error.code === "account_number_invalid") {
          setModalContent("Please enter valid Bank Account number.");
          setModalLink('');
          toggleModal();
        } else {
          setModalContent(result.error.message);
          setModalLink('');
          toggleModal();
        }
      } else {
        let response
        if (modalType === 'buyerToBothBuySellConversion') {
          let dataVal = {
            forSelling: true,
            token: result.token.id,
            name: props.values.accountHolderName,
            forReseller: true,
            accountToken: accountToken,
            drivingLicense: props.values.taxIdType === '0' ? pageData?.userDetails?.license : props.values.drivingLicense,
            uploadImage: props.values.taxIdType === '0' ? pageData?.userDetails?.uploadImage : props.values.drivingLicenseDoc,
            dob: props.values.taxIdType === '0' ? pageData?.userDetails?.dob : props.values.taxIdType === '2' ? props.values.dob : '',
            taxId: props.values.taxIdType === '1' ? props.values.taxId : pageData?.userDetails?.tax
          }
          response = await dispatch(profileCreateBuyerSeller(dataVal, token));
        } else if (modalType === 'sellerRemittanceDetailsAdd') {
          // if this is independent acc and adding seller payment for the first time 'paymentMethod/independent/create' api is used
          // else 'paymentMethod/create' is used
          if (pageData?.userDetails?.locationType === 'INDEPENDENT' &&
            (!pageData?.sellerPaymentDetails?.bankDetails || pageData?.sellerPaymentDetails?.bankDetails?.length === 0) &&
            (!pageData?.sellerPaymentDetails?.cardDetails || pageData?.sellerPaymentDetails?.cardDetails?.length === 0)) {
            let data = {
              forSelling: true,
              token: result.token.id,
              name: props.values.accountHolderName,
              accountToken: accountToken,
              drivingLicense: props.values.taxIdType === '0' ? pageData?.userDetails?.license : props.values.drivingLicense,
              uploadImage: props.values.taxIdType === '0' ? pageData?.userDetails?.uploadImage : props.values.drivingLicenseDoc,
              dob: props.values.taxIdType === '0' ? pageData?.userDetails?.dob : props.values.taxIdType === '2' ? props.values.dob : '',
              taxId: props.values.taxIdType === '1' ? props.values.taxId : pageData?.userDetails?.tax
            }
            response = await dispatch(paymentMethodProfileCreate(data, token));
          } else {
            let data = {
              forSelling: true,
              token: result.token.id,
              name: props.values.accountHolderName,
            }
            response = await dispatch(paymentMethodCreate(data, token));
          }
        }
        if (response.status === "SUCCESS") {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
          setPaymentType("bankAccount")
          setModalAlert('cardValidated')
        } else {
          if (response.statusCode === 401) {
            history.push('/sign-in');
            window.location.reload(false);
          } else {
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
          }
        }
      }
    }
  };

  const bankAccount = (props) => {
    const { isValid, dirty } = props;
    if (paymentType !== "bankAccount") {
      return null; // Don't render anything if the payment type is not bankAccount
    }
    return (
      <>
        <div><p>Account Holder Name<span class="star">*</span></p>
          <div>
            <TextInput
              name='accountHolderName'
              inputType="text"
              placeholder="Account Holder Name"
            />
          </div>
        </div>
        <div><p>Bank Account Number<span class="star">*</span></p>
          <div>
            <NumberInput
              name='bankAccount'
              placeholder='Account Number'
              maxLength='20'
            />
          </div>
        </div>
        <div><p>Bank Routing Number<span class="star">*</span></p>
          <div>
            <NumberInput
              name='bankRouting'
              placeholder='Routing Number'
              maxLength='20'
            />
          </div>
        </div>
        <Button
          type='app-green-button'
          disabled={!(isValid && dirty)}
          handleClick={() => {
            submitHandler(props);
          }}
        >
          Submit
        </Button>
      </>
    )
  }

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='card-modal'>
        <div className='modal-content modal-content-wrapper'>
          <div className='header'>
            <Button handleClick={() => {
              setPaymentType("bankAccount")
              if (modalType === "buyerToBothBuySellConversion" || modalType === "sellerToBothBuySellConversion") {
                onClickHander('close')
              } else {
                onClickHander()
              }
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>Sellers Remittance Information</h3>
          </div>
          <ModalBody>
          {loaderVisible && <Spinner />}
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className='modal-content modal-content-styles'>
              <Formik
                validateOnMount
                enableReinitialize={true}
                initialValues={getRegisterInitialValues()}
                validationSchema={VALIDATION_SCHEMA(selectTaxId)}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  const { values, setFieldValue, setTouched, validateForm, isValid, dirty } = props;
                  return (
                    <Form className="form">
                      <div><div class="app-input-text"></div></div>
                      {((pageData?.sellerPaymentDetails?.bankDetails?.length === 0 || !pageData?.sellerPaymentDetails?.bankDetails) && (pageData?.sellerPaymentDetails?.cardDetails?.length === 0 || !pageData?.sellerPaymentDetails?.cardDetails)) &&
                        <div className="col-12 displayFlex">
                          <div>
                            {taxLicenseOptions?.map((value, index) => (
                              <div key={index}>
                                <Field
                                  component={RadioButton}
                                  name="taxIdType"
                                  className="radio-label"
                                  id={value.value}
                                  defaultValue={taxLicenseOptions[0].value}
                                  onSelect={(e) => onChangeTaxHandler(e, props, setFieldValue)}
                                  label={value.label}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      }

                      {(props.values.taxIdType === '1' && taxLicenseOptions) &&
                        <div><p>Tax Id<span class="star">*</span></p>
                          <div>
                            <DecimalNumberInput name='taxId' decimalSeparator={false} maxLength={9} placeholder='Tax Id' />
                          </div>
                        </div>}

                      {(props.values.taxIdType === '2' && taxLicenseOptions) &&
                        licenseTypeAttach(props)}

                      <div className="col-12 displayFlex">
                        <div>
                          {radioTypes?.map((value, index) => (
                            <div key={index}>
                              <Field
                                component={RadioButton}
                                name="accountType"
                                className="radio-label"
                                id={value.value}
                                defaultValue={radioTypes[0].value}
                                onSelect={(e) => onChangeHandler(e, props, setFieldValue)}
                                label={value.label}
                              />
                            </div>
                          ))}
                        </div>
                      </div>

                      {paymentType === "bankAccount" && bankAccount(props)}
                      {paymentType === "debitCard" &&
                        <DebitForm
                          pageData={pageData}
                          modalType={modalType}
                          taxLicenseOptions={taxLicenseOptions}
                          paymentType='Selling'
                          props={props}
                          callBackModal={callBackModal}
                          callBackFetchApi={() => {
                            onClickHander("payment")
                          }}
                          callBack={() => {
                            callBackFun()
                          }}
                          setTouched={setTouched}
                          validateForm={validateForm}
                          pageLanguageContents={pageLanguageContents} />
                      }
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
      </Modal>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={modalAlert}
        callBackAlert={(val) => {
          if (val === 'cardValidated') {
            onClickHander("payment")
          }
        }}
      />
    </div>
  );
};